var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 63,
    viewBox: "0 0 234 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.068 52.7674H75.6244V12.1589H87.8985V41.1862H103.068V52.7674Z",
    fill: "#01C37D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7494 52.7674H58.4753C58.4753 52.7674 51.8433 42.2008 50.5317 39.8994C50.5317 39.8994 50.4575 50.4413 50.5317 52.7674H38.2576V12.1342H50.5317C51.2741 13.4457 58.2773 29.5802 58.4753 29.9514V12.1342H70.7494C70.6751 17.0587 70.6751 50.4165 70.7494 52.7674Z",
    fill: "#01C37D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3826 52.7674H21.3065L16.7037 25.2744L12.1009 52.7674H0L6.50825 12.0599H26.8991L33.3826 52.7674Z",
    fill: "#01C37D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M234 52.7674H216.727L205.641 41.7059V52.7674H193.367V12.1837H205.641V23.27L216.727 12.1837H233.654L213.782 32.4755L234 52.7674Z",
    fill: "#01C37D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.943 30.7928C107.943 35.4946 109.626 40.0479 112.669 43.6361C115.713 47.2243 119.945 49.5999 124.597 50.3423C129.249 51.0847 134.001 50.1443 138.01 47.6944C142.018 45.2446 145.037 41.4337 146.497 36.9793C147.957 32.5003 147.784 27.65 146.003 23.2947C144.221 18.9394 140.954 15.3512 136.772 13.1982C132.59 11.0453 127.789 10.4514 123.211 11.5155C118.633 12.5796 114.6 15.2522 111.803 19.0384L127.715 30.768H107.943V30.7928Z",
    fill: "#01C37D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.492 30.7928C188.492 35.4946 186.809 40.0479 183.765 43.6361C180.721 47.2243 176.49 49.5999 171.838 50.3423C167.185 51.0847 162.434 50.1443 158.425 47.6944C154.416 45.2446 151.397 41.4337 149.937 36.9793C148.477 32.5003 148.65 27.65 150.432 23.2947C152.214 18.9394 155.48 15.3512 159.662 13.1982C163.845 11.0453 168.645 10.4514 173.223 11.5155C177.801 12.5796 181.835 15.2522 184.631 19.0384L168.72 30.768H188.492V30.7928Z",
    fill: "#01C37D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.23 40.3448L154.441 46.5561L148.23 52.7674L142.018 46.5561L148.23 40.3448Z",
    fill: "#01C37D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnlook);
export default __webpack_public_path__ + "static/media/Anlook.95e2e307476833933806094b05cc0599.svg";
export { ForwardRef as ReactComponent };